import { FC } from 'react';
import { Divider } from 'antd';

import { LearnMoreFooter } from '@/shared';

import AdvancedSettingsViewHeader from '../components/AdvancedSettingsViewHeader';
import AuthorizedMethodsSection from './components/AuthorizedMethodsSection';
import CustomSubdomainsSection from './components/CustomSubdomainsSection';
import NetworkAccessSection from './components/NetworkAccessSection';

const Access: FC = (): JSX.Element => {
    return (
        <>
            <AdvancedSettingsViewHeader
                description='Manage all of your workspace access preferences here.'
                title='Access'
            />
            <CustomSubdomainsSection />
            <NetworkAccessSection />
            <AuthorizedMethodsSection />
            <Divider style={{ margin: '1rem 0' }} />
            <LearnMoreFooter topic={<>access preferences</>} />
        </>
    );
};

export default Access;
